module.exports = __webpack_public_path__ + "img/23.18d1e76d.svg";